<script>
  import { onMount } from "svelte";
  import Historyback from "../components/Historyback.svelte";
  import Collapse from "../components/Collapse.svelte";

  onMount(() => {
    window.scroll(0, 0);
  });
</script>

<style>
  ol {
    margin-block-start: .25rem;
  }
</style>

<div class="flex jc-between">
  <h2>メール受信設定方法</h2>
  <Historyback />
</div>
<div class="list mb-1">
  <div class="list-item list-item-action">
    <Collapse>
      <span slot="header">docomoスマートフォンのドメイン指定受信設定方法</span>
      <span slot="body">
        <ol>
          <li>「dメニュー」にアクセスし「お客様サポート」→「メール設定」へ移動します。</li>
          <li>「詳細設定／解除」を選択します。</li>
          <li>「認証画面」でspモードパスワードを入力して「決定」を選択します。</li>
          <li>「迷惑メール対策」画面で「受信／拒否設定」の「設定」を選び、「次へ」を選択します。</li>
          <li>「ステップ4」の「受信設定」に進み、『＠funity-rs.jp』を[　]に入力後、「登録」を選択し、設定完了です。</li>
        </ol>
        <p class="hint">※「i-Menu」のメニュー画面は随時変わる場合があります。</p>
      </span>
    </Collapse>
  </div>
  <div class="list-item list-item-action">
    <Collapse>
      <span slot="header">auスマートフォンのドメイン指定受信設定方法</span>
      <span slot="body">
        <ol>
          <li>画面下の「メール」のアプリを起動します。</li>
          <li>「設定」を選択します。</li>
          <li>「Eメール設定」を選択します。</li>
          <li>「その他の設定」を選択します。</li>
          <li>「パケット通信料が発生します」のメッセージが表示されたら、「ＯＫ」ボタンを押します。</li>
          <li>「迷惑フィルター」を選択します。</li>
          <li>「暗証番号」を入力し「送信」ボタンを押します。</li>
          <li>「詳細設定」を選択します。</li>
          <li>「指定受信リスト設定」で「設定する」にチェックを入れ「次へ」ボタンを押します。</li>
          <li>入力欄に「＠funity-rs.jp」と入力して「登録」を選択します。</li>
          <li>内容を確認し「登録」ボタンを押します。</li>
        </ol>
        <p class="hint">※ 迷惑フィルターの設定画面は随時変わる場合があります。</p>
      </span>
    </Collapse>
  </div>
  <div class="list-item list-item-action">
    <Collapse>
      <span slot="header">iPhone(au)のドメイン指定受信設定方法</span>
      <span slot="body">
        <ol>
          <li>「メッセージ」をタップします。</li>
          <li>宛先に「#5000」、本文に「1234」を入力し「送信」をタップします。</li>
          <li>受信したSMSに記載されている「メール設定URLをタップ後、メール設定画面にアクセスします。
            <p class="hint mb-0">※メッセージ（SMS）の受信には時間が掛かる場合があります。<br />※メッセージ（SMS）着信から60分以内にアクセスしてください。60分を越えてのアクセスはエラーとなります。エラーとなった場合には、再度「#5000」宛へメッセージ（SMS）を送信して下さい。</p>
          </li>
          <li>EZwebメール設定画面を下にスクロールし、「Eメールアドレス変更・迷惑メールフィルター・自動転送」をタップします。</li>
          <li>「迷惑メールフィルター」をタップします。</li>
          <li>au電話ご契約時に設定された「暗証番号」を入力し、「送信」をタップします。</li>
          <li>「指定受信リスト設定」をタップします。</li>
          <li>「設定する」にチェックをいれ、「次へ」をタップします。</li>
          <li>「＠funity-rs.jp」を入力し、「登録」をタップします。</li>
          <li>キーワードが「＠funity-rs.jp」になっていることを確認して「登録」をタップします。</li>
          <li>「登録が完了しました」の画面が表示されたら指定受信リスト設定完了です。</li>
        </ol>
      </span>
    </Collapse>
  </div>
  <div class="list-item list-item-action">
    <Collapse>
      <span slot="header">softbankスマートフォンのドメイン指定受信設定方法</span>
      <span slot="body">
        <ol>
          <li>ブラウザを起動し、画面下ブックマークアイコンを押します。</li>
          <li>「MySoftbank」を選択します。</li>
          <li>「ログインはこちら」を選択します。</li>
          <li>「携帯電話番号」「パスワード」を入力します。</li>
          <li>「メール設定」の「Eメール」を選択します。</li>
          <li>「迷惑メールブロック設定」の「次へ」ボタンを押します。</li>
          <li>「受信許可リスト」の「変更」ボタンを押します。</li>
          <li>「追加」をクリックします。</li>
          <li>「メールアドレスの一部(または全部)」に「＠funity-rs.jp」と入力し、「後方一致」にチェックをいれ、「次へ」をクリックします。</li>
          <li>「登録」をクリックし、設定完了です。</li>
        </ol>
        <p class="hint">※「MySoftbank」のメニュー画面は随時変わる場合があります</p>
      </span>
    </Collapse>
  </div>
  <div class="list-item list-item-action">
    <Collapse>
      <span slot="header">softbank(iPhone)のドメイン指定受信設定方法</span>
      <span slot="body">
        <dl>
          <dt>▼Eメール(i.softbank.jp)の場合</dt>
          <dd>
            <ol>
              <li>ブラウザ（safari）を起動し、画面下ブックマークアイコンを押します。</li>
              <li>「MySoftbank」を選択します。</li>
              <li>「ログインはこちら」を選択します。</li>
              <li>「携帯電話番号」「パスワード」を入力します。</li>
              <li>「メール設定」の「Eメール（i）」を選択します。</li>
              <li>「迷惑メールブロック設定」の「次へ」ボタンを押します。</li>
              <li>「受信許可リスト」の「変更」ボタンを押します。</li>
              <li>「追加」をクリックします。</li>
              <li>「メールアドレスの一部(または全部)」に「＠funity-rs.jp」と入力し、「後方一致」にチェックをいれ、「次へ」をクリックします。</li>
              <li>「登録」をクリックし、設定完了です。</li>
            </ol>
          </dd>
          <dt>▼SMS/MMSの場合</dt>
          <dd>
            <ol>
              <li>ブラウザ（safari）を起動し、画面下ブックマークアイコンを押します。</li>
              <li>「MySoftbank」を選択します。</li>
              <li>「ログインはこちら」を選択します。</li>
              <li>「携帯電話番号」「パスワード」を入力します。</li>
              <li>メール設定の「SMS/MMS」を選択します。</li>
              <li>迷惑メールブロックの設定「変更する」ボタンを押します。</li>
              <li>個別設定「個別設定はこちら」を選択します。</li>
              <li>受信許可・拒否設定（受信許可リスト設定）を選択。</li>
              <li>受信許可リストに「＠funity-rs.jp」と入力し、「後方一致」にチェックします。</li>
              <li>「設定する」ボタンを押します。</li>
            </ol>
            <p class="hint">※「MySoftbank」のメニュー画面は随時変わる場合があります。</p>
          </dd>
      </span>
    </Collapse>
  </div>
</div>
<div class="flex jc-end">
  <Historyback />
</div>
